import { apiFetch } from '@/lib/apiClient'
import type {
  PublicCaseTracking,
  PublicUploadLinkInfo,
  TrackByReferenceInput,
  TrackByReferenceResult,
} from '@/features/public/types'

/**
 * Both endpoints are `@Public()` — no bearer token to attach, so these call `apiFetch` directly
 * rather than going through `useApiFetch()`. The optional `baseUrl` reuses `apiFetch`'s existing
 * override (Phase 0) so the exact same function serves the client hook (default
 * `NEXT_PUBLIC_API_URL`) and a Server Component's `fetchQuery` (passing
 * `serverEnv.API_INTERNAL_URL`) without a second "server variant" or `serverApiFetch`'s
 * Clerk-`auth()`-dependent wrapper.
 */
export function fetchPublicCaseTracking(
  trackingToken: string,
  baseUrl?: string,
): Promise<PublicCaseTracking> {
  return apiFetch<PublicCaseTracking>(
    `/api/v1/public/cases/track/${trackingToken}`,
    baseUrl ? { baseUrl } : {},
  )
}

export function fetchPublicUploadLinkInfo(
  token: string,
  baseUrl?: string,
): Promise<PublicUploadLinkInfo> {
  return apiFetch<PublicUploadLinkInfo>(
    `/api/v1/public/upload-links/${token}`,
    baseUrl ? { baseUrl } : {},
  )
}

/** "Track My Status" — a plain JSON POST, no `Idempotency-Key` (a lookup, not a write). */
export function trackByReference(input: TrackByReferenceInput): Promise<TrackByReferenceResult> {
  return apiFetch<TrackByReferenceResult>('/api/v1/public/cases/track-by-reference', {
    method: 'POST',
    body: JSON.stringify(input),
  })
}
